import impactLogo from "./images/Impact App icon and Logo 1.png";
import download from "./images/download.png";
import appIcon from "./images/App icon with logo 2.png";
import googlePlayStore from "./footer/googlePlayStore.png";
import appStore from "./footer/appleStore.png";
import instagram from "./images/instagram.png";
import facebook from "./images/facebook.png";
import twitter from "./images/twitter.png";
import linkedin from "./images/linkedin.png";
import girlPh from "./hero/girlph.png";
import userIdentityPhoto from "./hero/userIdentityphoto.png";
import boyPh from "./hero/boyph.png";
import boyIdentityphoto from "./hero/boyIdentityphoto.png";
import rightBlock from "./hero/rightblock.png";
import playStore from "./images/google-play-store.png";
import appleStore from "./images/apple-app-store.png";
import star from './images/star-states.png'
import mobile from './work/mobile.png'
import mobile1 from './work/mobile1.png'
import mobile2 from './work/mobile2.png'
import mobile3 from './work/mobile3.png'
import reward from './work/reward.png'
import donate from './work/donate.png'
import stepDownload from './work/download.png'
import leftArrow from './charity/leftarrow.png'
import rightArrow from './charity/rightarrow.png'
import map from './stats/map.png'
import schaudhari from './testimony/schaudhari.png'
import haarika from './testimony/haarika.png'
import manoj from './testimony/manoj_agarwar_dp.png'
import aashi from './testimony/aashi jain.png'
import sbi from './partner/sbi.png'
import hdfc from './partner/hdfc.png'
import accenture from './partner/accenture.png'
import vedanta from './partner/vedanta.png'
import rblbank from './partner/rblbank.png'
import alkem from './partner/alkem.png'
import hero from './partner/hero.png'
import marico from './partner/marico.png'
import suzlon from './partner/suzlon.png'
import nmdc from './partner/nmdc.png'
import nideo from './partner/nideo.png'
import kshamata from './partner/kshamata.png'
import hesco from './partner/hesco.png'
import salam from './partner/salam.png'
import sankalp from './partner/sankalp.png'
import arrowRight from './about/arrow-right.png'
import thumbsUp from './contact/thumbsUp.png'
import contactPhoto from './contact/contactPhoto.png'
import offeringBg from './offerings/offeringbg.png'
import hdfcBank from './offerings/hdfcbank.png'
import heroMotor from './offerings/heromotor.png'
import apollo from './offerings/apollo.png'
import aarti from './offerings/aarti.png'
import knowArrow from './offerings/knowarrow.png'
import offering1 from './offerings/offering1.png'
import offering2 from './offerings/offering2.png'
import offering3 from './offerings/offering3.png'
import comejoinBg from './about/comejoinbackground.png'
import one from './causeBranding/one.png'
import two from './causeBranding/two.png'
import three from './causeBranding/three.png'
import four from './causeBranding/four.png'
import causeCard from './causeBranding/causeCard.png'
import downloadIcon from './causeBranding/downloadIcon.png'
import donateIcon from './causeBranding/donateIcon.png'
import rewardIcon from './causeBranding/rewardIcon.png'
import totalUserMap from './causeBranding/totalUserMap.png'
import handMobile from './causeBranding/handMobile.png'
import causeMobile from './causeBranding/causeMobile.png'
import analyticGirl from './causeBranding/Analyticgirl.png'
import marketingMobile from './marketingBrands/marketingMobile.png'
import fitnessGirl from './marketingBrands/fitnessGirl.png'
import handleMobile from './impactLeague/handleMobile.png'
import leaderboard from './impactLeague/Leaderboard.png'
import people from './impactLeague/people.png'
import employee from './impactLeague/employee.png'
import healthcare from './impactLeague/healthcare.png'
import competition from './impactLeague/competition.png'
import man from './impactLeague/man.png'
import hand from './impactLeague/hand.png'
import ready from './impactLeague/ready.png'
import clap from './impactLeague/clap.png'
import exercise from './impactLeague/exercise.png'
import running from './impactLeague/running.png'
import impactStore from './marketingBrands/impactStore.png'
import officeGirl from './careers/officeGirl.png'
import officeBoy from './careers/officeBoy.png'
import iGallery1 from './careers/iGallery1.png'
import iGallery2 from './careers/iGallery2.png'
import iGallery3 from './careers/iGallery3.png'
import iGallery4 from './careers/iGallery4.png'
import iGallery5 from './careers/iGallery5.png'
import iGallery6 from './careers/iGallery6.png'
import iGallery7 from './careers/iGallery7.png'
import iGallery8 from './careers/iGallery8.png'
import globeImg from './about/Globeimg.png'
import leadership from './about/leadership/leadershipphoto.png'
import starFull from './testimony/starfull.png'
import leftHand from './work/leftHand.png'
import boat from './marketingBrands/boat.png'
import eatAnytime from './marketingBrands/eatAnytime.webp'
import gizmore from './marketingBrands/gizmore.jpg'
import maxprotein from './marketingBrands/maxprotein.jpg'
import offeringBgMobile from './offerings/offeringBgMobile.png'
import comejoinBgMobile from './about/bgMobile.png'
import galleryPic1 from './careers/galleryPic1.png'
import galleryPic2 from './careers/galleryPic2.png'
import galleryPic3 from './careers/galleryPic3.png'
import galleryPic4 from './careers/galleryPic4.png'
import lastPitchTablet from './images/lastPitchTablet.png'
import comejoinBgTablet from './about/comejoinBgTablet.png'
import aadhar from './causeBranding/partnersLogo/aadhar.png'
import arcesium from './causeBranding/partnersLogo/arcesium.png'
import avanse from './causeBranding/partnersLogo/avanse.png'
import crompton from './causeBranding/partnersLogo/crompton.png'
import idfc from './causeBranding/partnersLogo/idfc.png'
import jll from './causeBranding/partnersLogo/jll.png'
import pantaloons from './causeBranding/partnersLogo/pantaloons.png'
import schlumberger from './causeBranding/partnersLogo/schlumberger.png'
import thermofisher from './causeBranding/partnersLogo/thermofisher.png'
import uno from './causeBranding/partnersLogo/uno.png'
import vedantalogo from './causeBranding/partnersLogo/vedanta.png'
import mahindra from './causeBranding/partnersLogo/mahindra.png'



export const images = {
  impactLogo,
  download,
  appIcon,
  googlePlayStore,
  appStore,
  instagram,facebook,twitter,linkedin,
  girlPh,boyPh,userIdentityPhoto,boyIdentityphoto,
  rightBlock,
  playStore,
  appleStore,
  star,
  mobile,mobile1,mobile2,mobile3,
  reward,
  donate,
  stepDownload,
  leftArrow,
  rightArrow,
  map,
  schaudhari,haarika,manoj,aashi,
  sbi,hdfc,accenture,vedanta,rblbank,alkem,hero,marico,suzlon,nmdc,nideo,kshamata,hesco,salam,sankalp,arrowRight,
  thumbsUp,
  contactPhoto,
  offeringBg,
  hdfcBank,heroMotor,apollo,aarti,
  knowArrow,
  offering1,offering2,offering3,
  comejoinBg,
  one,two,three,
  four,causeCard,
  downloadIcon,donateIcon,rewardIcon,
  totalUserMap,
  handMobile,causeMobile,analyticGirl,
  marketingMobile,fitnessGirl,
  handleMobile,leaderboard,
  people,employee,healthcare,
  ready,clap,exercise,running,competition,man,hand,
  impactStore,
  officeGirl,officeBoy,
  iGallery1,iGallery2,iGallery3,iGallery4,iGallery5,iGallery6,iGallery7,iGallery8,
  globeImg,leadership,starFull,
  leftHand,
  boat,eatAnytime,maxprotein,gizmore,
  offeringBgMobile,comejoinBgMobile,
  galleryPic1,galleryPic2,galleryPic3,galleryPic4,
  lastPitchTablet,
  comejoinBgTablet,
  aadhar,arcesium,avanse,crompton,idfc,jll,pantaloons,schlumberger,thermofisher,uno,
  vedantalogo,mahindra
};
